import { StockContext, StockMutations } from "./types";


export const addStock = (
  context: StockContext,
  value: boolean
) => {
  context.commit(StockMutations.SetStock, value);
};
